exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".appteamdetail{position:relative;width:100%;min-height:calc(100vh - 100px);padding:50px 0;background:#fff;color:#172c62}.appteamdetail .container{opacity:0;animation-duration:2s;animation-name:fade;animation-fill-mode:forwards;margin:auto}.appteamdetail h3{font-size:26px;text-align:left;width:100%}.appteamdetail h5{padding:0;font-size:15px;text-align:left;width:100%;margin-bottom:30px}.member_detail{color:#000;text-align:left}.member_links{width:90%;margin:20px auto 0;display:flex;flex-wrap:wrap}.member_links .half{width:50%}.member_links a{color:#172c62;font-size:24px}.back_button{width:80%;height:40px;margin:30px auto;display:flex;border:1px solid #172c62;justify-content:center;align-items:center}.back_button a{color:#172c62;font-size:21px;text-decoration:none}@keyframes fade{0%{opacity:0}to{opacity:1}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4224878c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AppTeamDetail.vue
// module id = 43
// module chunks = 0